import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=d08bdc3e&scoped=true&"
import script from "./TaskList.vue?vue&type=script&lang=js&"
export * from "./TaskList.vue?vue&type=script&lang=js&"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=d08bdc3e&lang=scss&scoped=true&"
import style1 from "./TaskList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08bdc3e",
  null
  
)

export default component.exports